import React, { useContext, useState } from "react";

import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import BaseDropdown from "../../components/ui/BaseDropdown";
import { useNotificationsSocket } from "../../hooks/useNotificationsSocket";
import { Badge } from "@mui/material";
import Notifications from "./components/Notifications";
import Inbox from "./components/Inbox";
import { LayoutContext } from "../../context/LayoutContext";
import { UserType } from "../../utils/enum";
import useAuth from "../../hooks/useAuth";
import { useInbox } from "../../hooks/useInbox";
import { getHelpDeskChatUrl } from "../../utils/helpDeskChat";

const TopBar = ({ userData, onMenuToggle }) => {
  const { logout, auth } = useAuth();
  const { isBannerVisible } = useContext(LayoutContext);
  const navigate = useNavigate();
  const { unreadNotificationCount } = useNotificationsSocket();
  // Fetch the inbox on initial load so the badge count is available immediately.
  // Inbox component uses the same query key, so it reuses the cached data when
  // the dropdown opens — no double-fetch.
  const { unreadConversationCount } = useInbox();
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  // The message icon now opens the inbox (conversation list) instead of the
  // grouped message-notification list.
  const [isInboxDropdownOpen, setIsInboxDropdownOpen] = useState(false);
  const helpDeskChatUrl = getHelpDeskChatUrl();

  return (
    // <div className="flex border-b border-zinc-300 fixed top-0 bg-white z-30 w-[95%] py-2">
    // sm:fixed
    <div
      className={` sm:fixed sticky  2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full bg-white border-b border-zinc-300 z-40 flex items-center sm:justify-between justify-end px-4 py-2 transition-all ${
        isBannerVisible ? "top-[50px]" : "mt-0 top-0"
      }`}
    >
      <div className="flex items-center w-full">
        <button className="sm:hidden p-2 text-[#636B88]" onClick={onMenuToggle}>
          <i className="fa-light fa-bars text-xl"></i>
        </button>
      </div>

      <div className="flex items-center justify-end 2xl:mr-12 xl:mr-5 lg:mr-3 mr-1 relative">
        {/* <div className="flex items-center h-full border-r border-zinc-300 pr-4 cursor-default">
          <p className="text-sm font-normal">{userData?.billingRates[0]?.currency}</p>
          <p className="text-sm ml-0.5 font-normal">0.00</p>
        </div> */}
        {/* Opens a WhatsApp chat with the help desk. Falls back to the plain,
            inert icon when no number is configured, rather than linking
            somewhere broken. */}
        <div className="px-3 flex items-center">
          {helpDeskChatUrl ? (
            <a
              href={helpDeskChatUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Chat with our help desk on WhatsApp"
              title="Need help?"
              className="flex items-center text-[#111827] hover:text-primary transition-colors"
            >
              <i className="fa-light fa-circle-question text-2xl"></i>
            </a>
          ) : (
            <i className="fa-light fa-circle-question text-[#111827] text-2xl"></i>
          )}
        </div>
        <div className="px-3">
          <Badge
            onClick={(e) => {
              e.stopPropagation();
              setIsInboxDropdownOpen((prev) => {
                setIsNotificationDropdownOpen(false);
                setIsProfileDropdownOpen(false);
                return !prev;
              });
            }}
            className="cursor-pointer"
            color="secondary"
            size="small"
            badgeContent={unreadConversationCount}
            sx={{
              ".MuiBadge-badge": {
                minWidth: "10px",
                height: "18px",
                fontSize: "12px",
              },
            }}
          >
            <i className="fa-light fa-messages text-[#111827] text-xl"></i>
          </Badge>
          <Inbox
            isInboxDropdownOpen={isInboxDropdownOpen}
            setIsInboxDropdownOpen={setIsInboxDropdownOpen}
          />
        </div>
        <div className="px-3">
          <Badge
            onClick={(e) => {
              e.stopPropagation();
              setIsNotificationDropdownOpen((prev) => {
                setIsInboxDropdownOpen(false);
                setIsProfileDropdownOpen(false);
                return !prev;
              });
            }}
            className="cursor-pointer"
            color="secondary"
            size="small"
            badgeContent={unreadNotificationCount}
            sx={{
              ".MuiBadge-badge": {
                minWidth: "10px",
                height: "18px",
                fontSize: "12px",
              },
            }}
          >
            <i className="fa-light fa-bell-ring text-xl text-[#111827]"></i>
          </Badge>
          <Notifications
            isNotificationDropdownOpen={isNotificationDropdownOpen}
            setIsNotificationDropdownOpen={setIsNotificationDropdownOpen}
          />
        </div>
        <div
          className="py-2 pl-3"
          onClick={(e) => {
            e.stopPropagation();
            setIsProfileDropdownOpen((prev) => {
              setIsInboxDropdownOpen(false);
              setIsNotificationDropdownOpen(false);
              return !prev;
            });
          }}
        >
          <Avatar
            className="cursor-pointer"
            src={userData?.picture?.url}
            sx={{ width: 24, height: 24 }}
          />
          <BaseDropdown
            setOpen={setIsProfileDropdownOpen}
            open={isProfileDropdownOpen}
            className="w-[236px] top-[40px] shadow-none -left-[25px] "
            style={{
              boxShadow: "0 1px 10px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-default border-b rounded-t-lg">
              <p>ID: {userData?.id}</p>
              <p className="capitalize font-normal">
                {`${userData?.firstName} ${userData?.lastName}`}
              </p>
            </div>
            <div
              className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b "
              onClick={() => {
                navigate(`/user/details/profile/${userData?.id}`);

                setIsProfileDropdownOpen(false);
              }}
            >
              <p className="capitalize">My Profile</p>
            </div>

            <div
              className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b"
              onClick={() => {
                navigate(`/user/settings/profileInformation/${userData?.id}`);
                setIsProfileDropdownOpen(false);
              }}
            >
              <p className="capitalize">Profile Setting</p>
            </div>

            {(userData?.role?.role === UserType.CLIENT ||
              userData?.role?.role === UserType.FREELANCER) &&
              userData?.isCompanyOwner && (
                <div
                  className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b"
                  onClick={() => {
                    navigate(`/company/settings`);
                    setIsProfileDropdownOpen(false);
                  }}
                >
                  <p className="capitalize">Company Setting</p>
                </div>
              )}

            {userData?.role?.role === UserType.CUSTOMER &&
              (auth?.user?.isCustomerOwner || !!userData?.customer) && (
                <div
                  className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b"
                  onClick={() => {
                    navigate(`/customerSettings/companyDetails`);
                    setIsProfileDropdownOpen(false);
                  }}
                >
                  <p className="capitalize">Company Setting</p>
                </div>
              )}
            <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b">
              <p className="capitalize">Help & Support</p>
            </div>
            {/* <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b">
              <p className="capitalize">Developer Center</p>
            </div>
            <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b">
              <p className="capitalize">Legal</p>
            </div>
            <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b">
              <p className="capitalize">Privary Policy</p>
            </div>
            <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b">
              <p className="capitalize">Send Feedback</p>
            </div>
            <div className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer border-b">
              <p className="capitalize">Insecure FAQS</p>
            </div> */}
            <div
              className="hover:bg-[#F6F6F6]	 py-3 px-1 cursor-pointer rounded-b-lg"
              onClick={logout}
            >
              <p className="capitalize">Log Out</p>
            </div>
          </BaseDropdown>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
